// ABOUTME: Footer line under a long localized text: "translated · show original" toggle.
// ABOUTME: Used where the text block is tall enough to carry an explicit control (edit forms).

import { useTranslation } from "react-i18next"
import { TranslateIcon } from "@shared/icons"
import { L10nLockedHint } from "./L10nLockedHint"
import { L10nTranslatingHint } from "./L10nTranslatingHint"
import type { L10nView } from "./fn"

interface IProps {
  view: L10nView
  /** Whether the caller is currently rendering the original instead of the translation. */
  showingOriginal: boolean
  onToggle: () => void
  className?: string
}

/**
 * Renders nothing when the text is the author's own — the common case, so the
 * note never adds noise to untranslated screens.
 */
export const L10nNote = ({ view, showingOriginal, onToggle, className = "" }: IProps) => {
  const { t } = useTranslation()

  if (view.badge === "none") {
    return null
  }

  if (view.badge === "locked") {
    return <L10nLockedHint className={className} />
  }

  if (view.badge === "pending") {
    return <L10nTranslatingHint className={className} />
  }

  return (
    <div className={`mt-1 flex items-center gap-1 text-xs text-gray-500 ${className}`}>
      <TranslateIcon size={12} />
      <span>{t("l10n.translated")}</span>
      {view.canShowOriginal && (
        <>
          <span aria-hidden="true">·</span>
          <button
            type="button"
            onClick={onToggle}
            className="text-blue-500 hover:underline"
          >
            {showingOriginal ? t("l10n.showTranslation") : t("l10n.showOriginal")}
          </button>
        </>
      )}
    </div>
  )
}

export default L10nNote
